import React from 'react';
import Input from '../input';
import { InputProps } from '../input/type.d';

function TextArea(props: InputProps) {
  const textProps = {
    rows: 3,
    itemType: 'textarea',
    linefeed: true,
    ...props,
  };

  return <Input {...textProps} />;
}

export default TextArea;
